<template>
    <div class="content">
        <router-link :to="'/'" tag="div" class="logo logo-white">Shop Logo</router-link>
        <telegram-button :style_class="'white'"></telegram-button>
        <email-button :style_class="'white'"></email-button>
        <div class="contact footer-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet
        </div>
        <social-button></social-button>
    </div>
</template>

<script>
    import EmailButton from './Buttons/EmailButton';
    import PhoneButton from './Buttons/PhoneButton';
    import SocialButton from './Buttons/SocialButton';
    import TelegramButton from './Buttons/TelegramButton';
    export default {
        name: "FooterContacts",
        components: { TelegramButton, SocialButton, EmailButton, PhoneButton }
    };
</script>

<style scoped lang="scss">
    .content {
        >div {
            margin-bottom: 12px;
            &.logo {
                cursor: pointer;
                margin-bottom: 16px;
            }
            &.footer-text {
                color: #FCFCFC;
                font-size: 14px;
                line-height: 21px;
                margin-bottom: 16px;
            }
        }
    }
</style>
